var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login" } }, [
    _c("div", { attrs: { id: "loginbg" } }),
    _c(
      "div",
      {
        attrs: { id: "loginform" },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleLogin($event)
          }
        }
      },
      [
        _vm._t("prefix"),
        _c("div", { staticClass: "welcome" }, [
          _c("p", { staticClass: "text chi" }, [
            _vm._v(
              _vm._s(
                _vm.welcomeTitle ? _vm.$t(_vm.welcomeTitle) : _vm.$t(_vm.title)
              )
            )
          ]),
          _c("p", { staticClass: "text eng" }, [_vm._v("WELCOME")])
        ]),
        _vm.tenantMode
          ? _c("div", { staticClass: "login_input" }, [
              _c("div", { staticClass: "login_icon" }, [_c("tenant-icon")], 1),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tenantId,
                    expression: "form.tenantId"
                  }
                ],
                attrs: { placeholder: _vm.$t("请输入") + _vm.$t("租户id") },
                domProps: { value: _vm.form.tenantId },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "tenantId", $event.target.value)
                  }
                }
              })
            ])
          : _vm._e(),
        _c("div", { staticClass: "login_input" }, [
          _c("div", { staticClass: "login_icon" }, [_c("user-icon")], 1),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.account,
                expression: "form.account"
              }
            ],
            attrs: { placeholder: _vm.$t("请输入") + _vm.$t("账号") },
            domProps: { value: _vm.form.account },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "account", $event.target.value)
              }
            }
          })
        ]),
        _c(
          "div",
          { staticClass: "login_input passwd" },
          [
            _c("div", { staticClass: "login_icon" }, [_c("passwd-icon")], 1),
            _vm.passwordType === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password"
                    }
                  ],
                  ref: "pass",
                  attrs: {
                    placeholder: _vm.$t("请输入") + _vm.$t("密码"),
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.password)
                      ? _vm._i(_vm.form.password, null) > -1
                      : _vm.form.password
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.password,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.form, "password", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "password",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "password", $$c)
                      }
                    }
                  }
                })
              : _vm.passwordType === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password"
                    }
                  ],
                  ref: "pass",
                  attrs: {
                    placeholder: _vm.$t("请输入") + _vm.$t("密码"),
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.form.password, null) },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "password", null)
                    }
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password"
                    }
                  ],
                  ref: "pass",
                  attrs: {
                    placeholder: _vm.$t("请输入") + _vm.$t("密码"),
                    type: _vm.passwordType
                  },
                  domProps: { value: _vm.form.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "password", $event.target.value)
                    }
                  }
                }),
            _vm.passwordType == "password"
              ? _c("passwd-show", {
                  nativeOn: {
                    click: function($event) {
                      return _vm.showPassword($event)
                    },
                    mousedown: function($event) {
                      $event.preventDefault()
                    },
                    mouseup: function($event) {
                      $event.preventDefault()
                    }
                  }
                })
              : _c("passwd-hide", {
                  nativeOn: {
                    click: function($event) {
                      return _vm.hidePassword($event)
                    },
                    mousedown: function($event) {
                      $event.preventDefault()
                    },
                    mouseup: function($event) {
                      $event.preventDefault()
                    }
                  }
                })
          ],
          1
        ),
        _c(
          "button",
          { staticClass: "loginbtn", on: { click: _vm.handleLogin } },
          [_vm._v(_vm._s(_vm.loginText))]
        ),
        _vm._t("affix")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }